import React from "react"
import types from "prop-types"
import { useCustomName } from "hooks"
import { DEPARTMENT_KEY } from "utils/customNameHelpers"
import {
  FACILITY_ATTRIBUTES_TAB_SLUG,
  FACILITY_AUDIT_TRAIL_TAB_SLUG,
  FACILITY_DEPARTMENTS_TAB_SLUG,
  FACILITY_GENERAL_TAB_SLUG,
} from "utils/tabSlugHelpers"
import { SideTabs } from "shared/tabs"
import AttributesTab from "./AttributesTab"
import GeneralTab from "./GeneralTab"
import DepartmentsTab from "./DepartmentsTab"
import AuditTrailTab from "./AuditTrailTab"

const TABS = (tabProps, departmentsTabTitle) => [
  {
    title: "General",
    slug: FACILITY_GENERAL_TAB_SLUG,
    TabContent: GeneralTab,
    props: tabProps,
  },
  {
    title: "Attributes",
    slug: FACILITY_ATTRIBUTES_TAB_SLUG,
    TabContent: AttributesTab,
    props: tabProps,
  },
  {
    title: departmentsTabTitle,
    slug: FACILITY_DEPARTMENTS_TAB_SLUG,
    TabContent: DepartmentsTab,
    props: tabProps,
  },
  {
    title: "Audit Trail",
    slug: FACILITY_AUDIT_TRAIL_TAB_SLUG,
    TabContent: AuditTrailTab,
    props: tabProps,
  },
]

const FacilityTabs = ({ tabProps = {} }) => {
  const { pluralName: departmentsTabTitle } = useCustomName(DEPARTMENT_KEY)

  return (
    <SideTabs tabs={TABS(tabProps, departmentsTabTitle)} />
  )
}

FacilityTabs.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  tabProps: types.object,
}

export default FacilityTabs
